import * as React from "react";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";
import Modal from "@insite/mobius/Modal";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ResolveThunks, connect, useDispatch, useSelector } from "react-redux";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import translate from "@insite/client-framework/Translate";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link from "@insite/mobius/Link";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import TextField from "@insite/mobius/TextField";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import PdpEstTruck from "@NA/Icons/PDPDocuments/PDPEstimateDateTruck";
import ADIColors from "@NA/Utils/ADIColors";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import LazyImage from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { EddModal, getEstimatedDeliveryDate } from "@NA/Services/ADIEstimatedDeliveryService";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ADILBShippedByVendor from "@NA/Components/ADILBShippedByVendor";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { EddContext } from "@NA/Utils/EddUtility";
import loadEddMethods from "@NA/Handlers/ADIGetEddMethodHandler";
import { useIsPRDomain } from "@NA/Utils/Utility";

export interface EstimatewrapperStyles {
    estStyles?: any;
    zipCode?: any;
    cancelButton?: any;
    updateButton?: any;
    buttonwrapper?: any;
    terms1?: any;
    terms2?: any;
    termsModal?: any;
    estIconStyles?: any;
    link?: any;
    errorMsgContainer?: InjectableCss;
    estlbiStyles?: InjectableCss;
    errorMsg?: TypographyProps;
}

const pdpEstimatewrapperStyles: EstimatewrapperStyles = {
    estStyles: {
        css: css`
            font-size: 13px;
            line-height: normal;
            font-weight: 600;
            color: #2d2926;
            margin-right: 5px;
            width: 100%;
            display: flex;
            border-bottom: 1px solid ${ADIColors.gray2};
            padding-bottom: 15px;
            margin-top: 15px;
            justify-content: center;
            [data-test-selector="stockAvailable"] {
                font-weight: 600;
                color: ${ADIColors.darkBlack3};
                ${TypographyStyle} {
                    font-weight: 600;
                    color: ${ADIColors.darkBlack3};
                }
            }
        `,
    },
    estlbiStyles: {
        css: css`
            font-size: 14px;
            line-height: normal;
            font-weight: 700;
            color: ${ADIColors.darkBlack3};
            margin-right: 5px;
            width: 100%;
            display: flex;
            margin-bottom: 15px;
            margin-top: 15px;
            justify-content: center;
            [data-test-selector="stockAvailable"] {
                font-weight: 700;
                font-size: 14px;
                color: ${ADIColors.darkBlack3};
                line-height: 19.1px;
                ${TypographyStyle} {
                    font-weight: 700;
                    font-size: 14px;
                    color: ${ADIColors.darkBlack3};
                    line-height: 19.1px;
                }
            }
        `,
    },
    zipCode: {
        css: css`
            max-width: 376px;
            width: calc(100% - 20px) !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);
            right: auto;
            height: 450px;
            position: fixed;
            border-radius: 2px;
        `,
    },

    updateButton: {
        css: css`
            margin-left: 20px;
        `,
    },
    buttonwrapper: {
        css: css`
            margin-top: 16px;
            text-align: right;
        `,
    },
    terms1: {
        css: css`
            margin-bottom: 22px;
            display: inline-block;
        `,
    },
    terms2: {
        css: css``,
    },
    termsModal: {
        css: css`
            max-width: 600px;
            width: calc(100% - 20px) !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);
            right: auto;
            min-height: 400px;
            position: fixed;
            border-radius: 2px;
        `,
        cssOverrides: {
            modalBody: css`
                padding: 28px;
                border-radius: 7px;
                box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.14);
            `,
            modalContainer: css``,
            modalTitle: css`
                border: none;
                padding: 0;
                h4 {
                    font-weight: bold;
                    color: #002856;
                    border: 0;
                    padding-bottom: 0;
                    margin-top: 0;
                    font-size: 28px;
                    margin-bottom: 11px;
                    padding: 0;
                }
            `,
            modalContent: css`
                padding: 0;
                span{
                    padding: 0;
                    font-size: 14px;
                    line-height: 1.71;
                    margin-bottom: 22px;
                },
            `,
        },
    },
    estIconStyles: {
        css: css`
            padding-right: 5px;
        `,
    },
    link: {
        css: css`
            &:hover {
                text-decoration: underline;
                cursor: pointer;
                color: #006ae3 !important;
            }
        `,
    },
    errorMsgContainer: {
        css: css`
            margin-top: 10px;
        `,
    },
    errorMsg: {
        css: css`
            font-weight: 800;
            margin-left: 5px;
        `,
    },
};

const mapStateToProps = (state: CustomApplicationState) => {
    const isAuthenticated = state.context.session!.isAuthenticated;
    const cartState = state.data.carts;
    const cartId = cartState?.currentId || "";
    const cart = cartState?.byId[cartId];
    const currentShipToState = getCurrentShipToState(state).value;
    const session = getSession(state);
    const billToId = session?.billToId;
    const catalogSettings = state.context.settings.settingsCollection.catalogSettingSettings as any;
    let customerNumber;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    const eddEstimatedDeliveryDates = state.ADIGlobalData.eddMethodStore.eddMethods?.itemsEdd;

    return {
        isAuthenticated,
        cart,
        currentShipToState,
        customerNumber,
        catalogSettings,
        eddEstimatedDeliveryDates,
    };
};

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const PDPEstimateDateSection: React.FC<Props> = ({
    product,
    cart,
    isAuthenticated,
    currentShipToState,
    customerNumber,
    catalogSettings,
    eddEstimatedDeliveryDates,
}) => {
    const isPRDomain = useIsPRDomain();
    if (isPRDomain) {
        return null;
    }
    const [openShippingCountdownModalOpen, setOpenShippingCountdownModalOpen] = React.useState<boolean>(false);
    const [openTermsModal, setOpenTermsModal] = React.useState<boolean>(false);
    const [state, setZipCodeState] = React.useState(currentShipToState?.postalCode);
    const [updatedZipCode, setZipCodeUpdated] = React.useState(state);
    const [estDate, setEstDate] = React.useState("");
    const [showErrorMsg, setShowErrorMsg] = React.useState(false);
    const [errorMsgToShow, setErrorMsgToShow] = React.useState("");
    const [eddFlag, setEddFlag] = React.useState<boolean>(false);
    const [formattedEstDate, setFormattedEstDate] = React.useState("");
    const [formattedEstDate2, setFormattedEstDate2] = React.useState("");
    const styles = pdpEstimatewrapperStyles;
    const specialOrderFlag =
        (catalogSettings.enableEdd &&
            product &&
            product.properties["inventoryMessage"] &&
            product.properties["inventoryMessage"] === "Special Order") ||
        ((product.properties.classificatioN_CODE === "S" ||
            product.properties.classificatioN_CODE === "P" ||
            product.properties.classificatioN_CODE === "L") &&
            product.properties["inventoryMessageType"] === "3");

    const isBCHCode =
        catalogSettings.enableEdd &&
        product &&
        (product.properties.classificatioN_CODE === "B" ||
            product.properties.classificatioN_CODE === "C" ||
            product.properties.classificatioN_CODE === "H");

    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );

    const dispatch: any = useDispatch();

    const isPRRegion = typeof window !== "undefined" && window.location.hostname.endsWith(".pr");

    React.useEffect(() => {
        setShowErrorMsg(false);
    }, []);

    // UseEffect for EDD implentation
    React.useEffect(() => {
        if (
            eddEstimatedDeliveryDates &&
            eddEstimatedDeliveryDates.length > 0 &&
            eddEstimatedDeliveryDates[0]?.item === product?.productNumber
        ) {
            updateValuesEDD(eddEstimatedDeliveryDates);
        }
    }, [eddEstimatedDeliveryDates]);

    const formatEddDateMonth = (dateString: string, isDateRange: boolean) => {
        const eddDateString = dateString.split("-");
        const monthName = [
            "Jan.",
            "Feb.",
            "March",
            "April",
            "May",
            "June",
            "July",
            "Aug.",
            "Sept.",
            "Oct.",
            "Nov.",
            "Dec.",
        ];
        const dateStringMonthNumber = Number(eddDateString[1]);
        const eddDate = `${monthName[dateStringMonthNumber - 1]} ${String(Number(eddDateString[2]))}`;

        if (!isDateRange) {
            const date = new Date(dateString);
            const day = `${date.toLocaleString("en-US", { weekday: "short", timeZone: "UTC" })}.`;
            const month = `${date.toLocaleString("en-US", { month: "short", timeZone: "UTC" })}.`;
            const dayOfMonth = date.getUTCDate();

            return `${day} ${month} ${dayOfMonth}`;
        }
        return eddDate;
    };

    const fetchEdd = async () => {
        try {
            dispatch(
                loadEddMethods({
                    customer: customerNumber ?? "",
                    zipcode: updatedZipCode ? updatedZipCode.trim() : "",
                    ordertype: "NS",
                    isSpecialOrder: specialOrderFlag,
                    items: product ? product.productNumber : "",
                    onSuccess(result: any) {
                        const res = result;
                        if (res && res.itemsEdd.length > 0) {
                            updateValuesEDD(res.itemsEdd);
                        }
                    },
                }),
            );
        } catch (err: any) {
            console.log(err.message);
        }
    };

    const closeShippingCountdownModal = () => {
        setOpenShippingCountdownModalOpen(false);
        setErrorMsgToShow("");
        setShowErrorMsg(false);
    };
    const closeTermsModal = () => {
        setOpenTermsModal(false);
    };
    const handleChange = (event: any) => {
        const zipCode = event.target.value.trim();
        setZipCodeUpdated(zipCode);
    };

    const udateValue = (modalOpen = "modalClose") => {
        if (isAuthenticated && updatedZipCode) {
            const zipCodeRegex = /^\d{5}$/;
            if (modalOpen === "openModal" && !zipCodeRegex.test(updatedZipCode)) {
                setErrorMsgToShow("Please enter a 5-digit Zip Code");
                setShowErrorMsg(true);
                return;
            }
            setShowErrorMsg(false);
            if (specialOrderFlag || isBCHCode) {
                fetchEdd();
                setZipCodeState(updatedZipCode);
                setOpenShippingCountdownModalOpen(false);
            }
        }
    };

    const openModal = () => {
        setZipCodeUpdated(state);
        setOpenShippingCountdownModalOpen(true);
    };

    if (isPendingVerification) {
        return null;
    }

    // New common method to update EDD state variables

    const updateValuesEDD = (eddEstimatedDeliveryDates: any) => {
        const edd = eddEstimatedDeliveryDates?.[0];
        if (!edd) return;
        // eslint-disable-next-line camelcase
        const { edd_UB, edd_LB } = edd;
        // eslint-disable-next-line camelcase
        const hasRange = edd_UB !== edd_LB;
        setEddFlag(hasRange);
        // eslint-disable-next-line camelcase
        setFormattedEstDate(formatEddDateMonth(hasRange ? edd_LB : edd_UB, hasRange));
        if (hasRange) {
            setFormattedEstDate2(formatEddDateMonth(edd_UB, true));
        }
    };

    return (
        <>
            {cart &&
                isAuthenticated &&
                product.properties["lbi"]?.toLowerCase() === "yes" &&
                product.properties["logicBroker"]?.toLowerCase() !== "yes" && (
                    <StyledWrapper {...styles.estlbiStyles} data-selector="estimationWrapper">
                        <ADILBShippedByVendor vendorName={product.brand?.name ?? ""} view="Grid" />
                    </StyledWrapper>
                )}
            {cart &&
                isAuthenticated &&
                product.properties["logicBroker"] &&
                product.properties["logicBroker"]?.toLowerCase() === "yes" && (
                    <StyledWrapper {...styles.estStyles} data-selector="estimationWrapper">
                        <Typography {...styles.estIconStyles}>
                            <PdpEstTruck />
                        </Typography>
                        <>
                            <ADILBShippedByVendor vendorName={product.brand?.name ?? ""} view="Grid" />
                        </>
                    </StyledWrapper>
                )}

            {cart &&
                isAuthenticated &&
                formattedEstDate &&
                formattedEstDate !== "Invalid Date" &&
                currentShipToState?.country?.name === "United States" &&
                !(product.properties["logicBroker"] && product.properties["logicBroker"]?.toLowerCase() === "yes") && (
                    <StyledWrapper
                        {...styles.estStyles}
                        style={{ flexDirection: "column", alignItems: "center" }}
                        data-selector="estimationWrapper"
                    >
                        {formattedEstDate && (
                            <StyledWrapper style={{ display: "flex" }}>
                                <Typography {...styles.estIconStyles}>
                                    <PdpEstTruck />
                                </Typography>

                                <Typography as="span">
                                    <Typography as="strong">Delivery: </Typography>
                                    <Typography as="strong" style={{ color: "#008000" }}>
                                        {!eddFlag ? translate("Estimated by") : translate("Estimated")}&nbsp;
                                    </Typography>
                                </Typography>
                                <Typography as="span" style={{ color: "#008000" }}>
                                    {formattedEstDate} {eddFlag ? `- ${formattedEstDate2}` : ""}&nbsp;
                                </Typography>
                            </StyledWrapper>
                        )}
                        {formattedEstDate && (
                            <StyledWrapper style={{ display: "flex", marginTop: "10px" }}>
                                <Typography as="strong">{translate("Zip Code")}&nbsp;</Typography>
                                {currentShipToState && currentShipToState?.postalCode && (
                                    <Link as="span" {...styles.link}>
                                        <Typography onClick={openModal}>{state} &nbsp;</Typography>
                                    </Link>
                                )}
                                <Typography style={{ color: ADIColors.gray2 }}>|&nbsp;&nbsp;</Typography>
                                <Link as="span" {...styles.link} onClick={() => setOpenTermsModal(true)}>
                                    <Typography as="span">{translate(" Terms ")}</Typography>
                                </Link>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                )}

            <Modal
                {...styles.zipCode}
                isOpen={openShippingCountdownModalOpen}
                handleClose={closeShippingCountdownModal}
                headline={translate("Change Zip Code")}
                sizeVariant="medium"
            >
                <StyledWrapper>
                    <Typography variant="p">
                        <Typography as="span">{translate(" Zip Code")}&nbsp;</Typography>
                        <TextField maxLength={5} value={updatedZipCode} onChange={handleChange}></TextField>
                        {showErrorMsg && (
                            <StyledWrapper {...styles.errorMsgContainer}>
                                <LazyImage src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/icon-error-circle.svg" />
                                <Typography {...styles.errorMsg}>{translate(errorMsgToShow)}</Typography>
                            </StyledWrapper>
                        )}
                        <StyledWrapper {...styles.buttonwrapper}>
                            <Button {...styles.cancelButton} onClick={closeShippingCountdownModal}>
                                Close
                            </Button>
                            <Button onClick={() => udateValue("openModal")} {...styles.updateButton}>
                                Update
                            </Button>
                        </StyledWrapper>
                    </Typography>
                </StyledWrapper>
            </Modal>
            <Modal
                isOpen={openTermsModal}
                handleClose={closeTermsModal}
                headline={translate(" Ship Availability Terms")}
                sizeVariant="medium"
                {...styles.termsModal}
            >
                <StyledWrapper>
                    <Typography as="span" {...styles.terms1}>
                        {translate("Terms 1")}
                    </Typography>
                    <Typography as="span" {...styles.terms2}>
                        {translate("Terms 2")}
                        {translate("Terms 3")}
                    </Typography>
                </StyledWrapper>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(PDPEstimateDateSection)),
    definition: {
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        displayName: "PDPEstimateDateSection",
    },
};
export default widgetModule;
